import type { InventorySources } from '@/types'

export type SegmentLogic = InventorySources.LogicalOperatorType // 'AND' | 'OR'

export function normalizeSegmentLogic(value: unknown, fallback: SegmentLogic = 'AND'): SegmentLogic {
  if (value === 'AND' || value === 'OR') return value
  if (typeof value === 'string') {
    const v = value.trim().toUpperCase()
    if (v === 'AND' || v === 'OR') return v as SegmentLogic
  }
  return fallback
}

/**
 * The backend segmentation schema supports a single `ruleset.logic` that joins all rules
 * (not per-rule joins). In the UI we show a connector per row; we treat that as a segment-level
 * setting and keep it consistent across the criteria array.
 */
export function deriveRulesetLogicFromCriteria(
  criteria: Array<{ logicalOperator?: unknown }> | undefined,
  fallback: SegmentLogic = 'AND',
): SegmentLogic {
  if (!Array.isArray(criteria) || criteria.length === 0) return fallback
  for (const c of criteria) {
    const logic = normalizeSegmentLogic(c?.logicalOperator, '' as any)
    if (logic === 'AND' || logic === 'OR') return logic
  }
  return fallback
}

export function rulesetToCriteria(ruleset: any): Array<{
  field: string
  operator: string
  value: unknown
  logicalOperator: SegmentLogic
}> {
  const logic = normalizeSegmentLogic(ruleset?.logic, 'AND')
  const rules = Array.isArray(ruleset?.rules) ? ruleset.rules : []
  return rules
    .filter((r: any) => r && r.type === 'rule')
    .map((rule: any) => ({
      field: rule.field,
      operator: rule.operator,
      value: rule.value,
      logicalOperator: logic,
    }))
}


